import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { BaseService } from '../shared/services/base.service';
import { Cliente } from '../models/cliente.model';
import { Page } from '../models/page.model';

@Injectable({
  providedIn: 'root'
})
export class ClienteService extends BaseService<Cliente> {

  constructor(protected injector: Injector) {
    super(`${environment.API_PRICE}/cliente`, injector);
  }

  pesquisar(cliente: Cliente): Observable<Page<Cliente>> {
    return this.http.post<Page<Cliente>>(`${environment.API_PRICE}/cliente/pesquisar`, cliente);
  }

  getByProposta(usuarioId: number): Observable<Cliente[]> {
    return this.http.get<Cliente[]>(`${environment.API_PRICE}/cliente/getByProposta/${usuarioId}`);
  }

  getClient(): Observable<Cliente[]> {
    return this.http.get<Cliente[]>(`${environment.API_PRICE}/CRM/GetClientes`);
  }

  getClientesAtivos(): Observable<Cliente[]> {
    return this.http.get<Cliente[]>(`${environment.API_PRICE}/cliente/GetAtivos`)
  }

  GetAllIncludeNotActive(): Observable<Page<Cliente>> {
    return this.http.get<Page<Cliente>>(`${environment.API_PRICE}/cliente/GetAllIncludeNotActive`)
  }

  atualizarClientesCRM() {
    return this.http.get(`${environment.API_PRICE}/crm/SincronizarClientes`);
  }

  /** Retorno: array de Cliente (cada um com unidades: Unidade[]). */
  getAllByUnidade(unidadeId: number): Observable<Cliente[]> {
    return this.http.get<Cliente[]>(`${environment.API_PRICE}/cliente/GetAllByUnidade/${unidadeId}`);
  }

  updateUnidade(cliente: Cliente): Observable<Page<Cliente>> {
    return this.http.put<Page<Cliente>>(`${environment.API_PRICE}/cliente/UpdateUnidade`, cliente);
  }

  getAllAtivos(): Observable<Page<Cliente>> {
    return this.http.get<Page<Cliente>>(`${environment.API_PRICE}/cliente/GetAll`);
  }
}